/** Мутация подтверждения e-mail по коду из письма. */
import { useMutation } from "@tanstack/react-query";
import { Api } from "@/api";
import { authKeys } from "./keys";

export const useConfirmEmail = () => {
	const mutation = useMutation({
		mutationFn: Api.Auth.postApiAuthEmailConfirm,
		mutationKey: authKeys.confirmEmail,
	});

	return {
		execute: mutation.mutateAsync,
		isPending: mutation.isPending,
	};
};
